import { Component } from "@angular/core";
import { SettingsComponent } from "../settings/settings.component";

@Component({
  selector: "app-settings-page",
  imports: [SettingsComponent],
  templateUrl: "./settings-page.component.html",
  styles: ``,
})
export class SettingsPageComponent {}
